
import { Textarea } from "@mantine/core";
import Button from "../../components/Button";

const PostJob = ({ handleUpdate, update, setUpdate }) => {
 
  return (
    <div className="status-update shadow">
      <div className="d-flex w-100 justify-content-between">
        <h5 className="text-dark">What's on your mind?</h5>
        {/* <a href={`/employer/settings/4`} className="text-decoration-none">
          My posts
        </a> */}
      </div>
      <Textarea
        placeholder="Update your connections..."
        value={update.status}
        onChange={(v) => setUpdate((e) => ({ ...e, status: v.target.value }))}
        minRows={3}
      />
      <Button
        title="Post News Update"
        primary={true}
        onClick={handleUpdate}
        width="160px"
        disable={!update.status}
        style={{ marginTop: "10px", marginLeft: "auto" }}
      />
    </div>
  );
};
export default PostJob;
